import type { OnlyRequired } from '@/types/util'
import { useProfileAccess } from '@/utils/hooks/usePermissions'
import { Link } from 'react-router'
import type { UserNode } from '../types.graphql'

export type ProfileLinkUser = OnlyRequired<UserNode, 'id' | 'fullName'> &
  Partial<Pick<UserNode, 'firstName' | 'lastName'>>

interface UserProfileLinkProps {
  user: ProfileLinkUser
  userNameTransform?: (user: ProfileLinkUser) => string
}

export const UserProfileLink: React.FC<UserProfileLinkProps> = ({
  user,
  userNameTransform,
}) => {
  const canAccessProfile = useProfileAccess(user)
  const label = userNameTransform?.(user) ?? user.fullName

  return canAccessProfile ? (
    <Link className="text-neutral-700" to={`/users/${user.id}`}>
      {label}
    </Link>
  ) : (
    <span className="text-neutral-700">{label}</span>
  )
}
